// extracted by mini-css-extract-plugin
export default {"buttons":"calculatorButtons_buttons__9hgc5","wrapper":"calculatorButtons_wrapper__G8TvO"};